import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "@/components/ui/sonner";

/**
 * Public site shell. Header, main outlet, footer.
 *
 * The AI reference desk lives INSIDE specific pages as an inline surface
 * (see <InlineAssistant/> on the Bill Tracker + Priority pages). It is
 * intentionally NOT a floating bubble sitewide — see the CCC design brief.
 */
export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-ccc-paper">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <Toaster position="top-center" />
    </div>
  );
}
